import styled from 'styled-components';
import { space } from 'styles/variables';

export const LoadingSpinnerContainer = styled.div`
  height: ${space.x6};
  position: relative;
`;
